module.exports = __webpack_public_path__ + "img/sports_grid.b10a9b9d.svg";